import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <div id='footer-left'>
        <ul>
          <li><Link to="/apropos" className='footer-link'>À propos</Link></li>
          <li><Link to="/contact" className='footer-link'>Contact</Link></li>
          <li><Link to="/mentions-legales" className='footer-link'>Mentions légales</Link></li>
        </ul>
      </div>

      <div id='footer-center'>
        <Link to="/" id='footer-logo'>
          <div><span className='tahin'>Tahin</span><span className='raw'>.raw</span></div>
        </Link>
      </div>

      <div id='footer-right'>
        <a href="https://linktr.ee/Tahin.raw" target='_blank' rel="noreferrer noopener" className='footer-link'>Mes réseaux</a>
      </div>

      <div id="footer-bottom">
        © {currentYear} <strong>Tahïn PIERDET</strong>. Tous droits réservés. Site réalisé par&nbsp;
        <a href="https://www.linkedin.com/in/antunesmathieu/" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline dotted' }}>
          Mathieu ANTUNES
        </a>
      </div>
    </footer>
  );
}
 
export default Footer;